module.exports = __webpack_public_path__ + "static/trig_013-6f64a12dbeb060f2b50ed8739ffe7308.webp";